/**
 * Formats a number according to the specified options
 * @param value - The number to format
 * @param options - Formatting options
 * @returns The formatted number as a string
 */
export function formatNumber(value, options) {
    const { Decimals = 0, Default, Prefix, Suffix, Plus, Comma, Compact } = options;
    if (value === 0 || isNaN(value) || value == null)
        return Default || '';
    // Determine decimal places based on auto settings
    let decimals = Decimals;
    if (Decimals === 'auto') {
        const absValue = Math.abs(value);
        if (absValue >= 1000) {
            decimals = 0;
        }
        else if (absValue >= 10) {
            decimals = 2;
        }
        else if (absValue >= 1) {
            decimals = 3;
        }
        else {
            decimals = 4;
        }
    }
    else if (Decimals === 'auto.2') {
        const absValue = Math.abs(value);
        if (absValue >= 10) {
            decimals = 2;
        }
        else if (absValue >= 1) {
            decimals = 3;
        }
        else {
            decimals = 4;
        }
    }
    // Second check for invalid values (duplicate from original code)
    if (value === 0 || isNaN(value) || value == null)
        return Default || '';
    const res = []; // output array
    let workingValue = value;
    // Handle sign
    if (workingValue < 0) {
        res.push('-');
        workingValue = -workingValue;
    }
    else if (workingValue > 0 && Plus) {
        res.push('+');
    }
    // Add prefix
    if (Prefix !== null && Prefix !== undefined) {
        res.push(Prefix);
    }
    let ext = ''; // Extension: K/M/B/T
    if (Compact) {
        if (workingValue >= 1000000000000) {
            workingValue /= 1000000000000;
            ext = "T";
        }
        else if (workingValue >= 1000000000) {
            workingValue /= 1000000000;
            ext = "B";
        }
        else if (workingValue >= 1000000) {
            workingValue /= 1000000;
            ext = "M";
        }
        else if (workingValue >= 1000) {
            workingValue /= 1000;
            ext = "K";
        }
    }
    let formattedValue = parseFloat(workingValue.toString()).toFixed(decimals);
    // Add comma separators
    if (Comma) {
        let end = formattedValue.indexOf('.');
        if (end === -1) {
            end = formattedValue.length;
        }
        if (end > 3) {
            const parts = [];
            const fraction = formattedValue.substring(end);
            let i = end - 3;
            for (; i > 0; i -= 3) {
                parts.push(formattedValue.substring(i, i + 3));
            }
            parts.push(formattedValue.substring(0, i + 3));
            formattedValue = parts.reverse().join(",") + fraction;
        }
    }
    res.push(formattedValue);
    res.push(ext);
    // Add suffix
    if (Suffix !== null && Suffix !== undefined) {
        res.push(Suffix);
    }
    return res.join("");
}
export default formatNumber;
//# sourceMappingURL=index.js.map